/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1NotificationMobileAppNotificationidPreviewQueryResponse,
  GetApiV1NotificationMobileAppNotificationidPreviewPathParams,
  GetApiV1NotificationMobileAppNotificationidPreview401,
  GetApiV1NotificationMobileAppNotificationidPreview404,
  GetApiV1NotificationMobileAppNotificationidPreview500,
} from "../../types/notificationMobileAppController/GetApiV1NotificationMobileAppNotificationidPreview.ts";

function getGetApiV1NotificationMobileAppNotificationidPreviewUrl(
  notificationId: GetApiV1NotificationMobileAppNotificationidPreviewPathParams["notificationId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/notification/mobile-app/${notificationId}/preview` as const,
  };
  return res;
}

/**
 * @description Retorna título, mensagem, turmas (nomes para exibição + IDs), status de matrícula, URL externa, agendamento e status atual da notificação. **(Requer Authorization para autenticação)**
 * @summary Retorna os dados de uma notificação para edição (Requer Authorization para autenticação)
 * {@link /api/v1/notification/mobile-app/:notificationId/preview}
 */
export async function getApiV1NotificationMobileAppNotificationidPreview(
  notificationId: GetApiV1NotificationMobileAppNotificationidPreviewPathParams["notificationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1NotificationMobileAppNotificationidPreviewQueryResponse,
    ResponseErrorConfig<
      | GetApiV1NotificationMobileAppNotificationidPreview401
      | GetApiV1NotificationMobileAppNotificationidPreview404
      | GetApiV1NotificationMobileAppNotificationidPreview500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1NotificationMobileAppNotificationidPreviewUrl(
      notificationId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
